<ami-dialog-message [setting]="message"></ami-dialog-message>
<p-sidebar
  [(visible)]="open"
  position="right"
  (onHide)="onClose()"
  [style]="{ width: '36em' }"
>
  <ng-template pTemplate>
    <div class="surface-card p-4 shadow-5 border-round">
      <div class="font-medium text-3xl text-900 mb-3">
        Actualizar cantidad del Producto
      </div>
      <div class="text-500 mb-5">
        Revisar la información del producto, antes de modificarlo.
      </div>
      <form [formGroup]="fg">
        <ul class="list-none p-0 m-0">
          <li
            *ngFor="let item of itemStock; let i = index"
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-5 font-medium">
              {{ item.label }}
            </div>
            <div
              *ngIf="
                item.label !== 'Margen' &&
                item.label !== 'Precio Compra' &&
                item.label !== 'Precio Venta'
              "
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              {{ item.value }}
            </div>
            <div
              *ngIf="
                item.label === 'Precio Compra' || item.label === 'Precio Venta'
              "
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              {{ item.value | currency: 'PEN' }}
            </div>

            <div
              *ngIf="item.label === 'Margen'"
              class="text-900 w-full ml-1 md:w-6 md:flex-order-0 flex-order-1"
            >
              {{ item.value | percent: '2.0-2' }}
            </div>
          </li>
          <li
            class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <div class="text-500 w-2 md:w-4 font-medium">Nuevo stock</div>
            <div class="w-auto md:w-8 md:flex-order-0 flex-order-1">
              <p-inputNumber
                mode="decimal"
                locale="en-IN"
                formControlName="newQuantity"
                class="size-1"
                [showButtons]="true"
                inputId="minmax-buttons"
                [maxFractionDigits]="0"
              >
              </p-inputNumber>
              <div
                *ngIf="
                  fg.get('newQuantity').invalid &&
                  (fg.get('newQuantity').dirty || fg.get('newQuantity').touched)
                "
                class="p-invalid"
              >
                <div *ngIf="fg.get('newQuantity').errors?.required">
                  <small class="p-error">No puede quedar vacio.</small>
                </div>
                <div *ngIf="fg.get('newQuantity').errors?.min">
                  <small class="p-error"> El valor mínimo es 0.</small>
                </div>
              </div>
            </div>
          </li>
          <li
            class="flex align-items-center justify-content-end flex-wrap py-3 px-2 border-top-1 surface-border flex-wrap"
          >
            <button
              pButton
              pRipple
              (click)="onClose()"
              icon="pi pi-times"
              class="p-button-text"
              pTooltip="Cancelar"
              tooltipPosition="left"
              label="No"
            ></button>
            <button
              (click)="onSubmit()"
              pButton
              pRipple
              class="p-button-text"
              icon="pi pi-check"
              [disabled]="fg.invalid"
              label="Si"
              pTooltip="Actualizar Stock"
              tooltipPosition="left"
            ></button>
          </li>
        </ul>
      </form>
    </div>
  </ng-template>
</p-sidebar>
